import { render, staticRenderFns } from "./sysStudentImgWrite.vue?vue&type=template&id=2a871592&scoped=true&"
import script from "./sysStudentImgWrite.vue?vue&type=script&lang=js&"
export * from "./sysStudentImgWrite.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentImgWrite.vue?vue&type=style&index=0&id=2a871592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a871592",
  null
  
)

export default component.exports